import { db } from './index'
import { collection, addDoc, serverTimestamp } from 'firebase/firestore'

/**
 * 관심고객 등록 (홈페이지 폼 → Firestore customers 컬렉션)
 *
 * @param {Object} data
 * @param {string} data.name           - 성함
 * @param {string} data.phone          - 연락처
 * @param {string} data.preferredDate  - 희망 상담 날짜 (YYYY-MM-DD)
 * @param {string} data.preferredTime  - 희망 상담 시간 (HH:mm)
 * @param {string} source              - 유입 경로
 */
export async function registerCustomer(data, source = 'mobile') {
  const docRef = await addDoc(collection(db, 'customers'), {
    name: data.name,
    phone: data.phone,
    preferredDate: data.preferredDate || '',
    preferredTime: data.preferredTime || '',
    source,
    status: 'new',
    createdAt: serverTimestamp()
  })
  return docRef.id
}
